/**
 * RcmLanding — the FSR landing surface for CIF search.
 *
 * Renders the shared `GlobalCustomerSearch` primitive. Clicking a result
 * navigates to /rcm/:cifId where CifDetail takes over.
 *
 * History: the earlier build had four segregated inputs (CIF / SSN / First /
 * Last). Gap G-RCM-01 / G-XM-01 — the shared primitive ports the legacy SPFx
 * `PersonSearchBar` auto-detect + parallel-query + kill-list filter pattern.
 */
import { useNavigate } from 'react-router';
import { GlobalCustomerSearch } from '@/components/primitives';
import type { CustomerSearchRow } from '@/components/primitives';
import { useEmitEvent } from './hooks/useEmitEvent';

export function RcmLanding(): JSX.Element {
  const emit = useEmitEvent();
  const navigate = useNavigate();

  const handleSelect = (row: CustomerSearchRow): void => {
    emit({
      eventType: 'rcm.cust.selected',
      eventCategory: 'cif-account',
      payload: { cifId: row.cifId, custType: row.custType },
    });
    navigate(`/rcm/${row.cifId}`);
  };

  return (
    <div className="rcm-landing">
      <header className="rcm-landing__header">
        <h1>CIF Management</h1>
        <div className="rcm-landing__sub">
          Find an existing customer by SSN, name, or CIF number.  Auto-detect:
          9-digit / dashed input → TaxId; 6+ digits → CIF; anything else → parallel
          name search.  Kill-listed CIFs are filtered before display.
        </div>
      </header>

      <GlobalCustomerSearch onSelect={handleSelect} />
    </div>
  );
}
